var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"flex-container"},_vm._l((_vm.sponsors),function(ref){
var company = ref.company;
var details = ref.details;
var id = ref.id;
return _c('div',{key:id},[_c('router-link',{attrs:{"to":{
          name: 'companyProfile',
          params: { companyId: _vm.getId(company) },
        },"exact":""}},[_c('img',{class:("sponsor-img " + ([0,1,2].includes(_vm.index) ? 'scale-up' : '')),attrs:{"src":details.logo,"alt":""}})])],1)}),0)}
var staticRenderFns = []

export { render, staticRenderFns }